export const GOOGLE_MAPS_REVIEWS_URL = 'https://maps.app.goo.gl/XG7o3iDHan29DHZx7';

export const GOOGLE_MAPS_RATING = 5.0;

export const GOOGLE_MAPS_REVIEW_COUNT = 2;

export const GOOGLE_REVIEW_KEYS = [
  { key: 'hippolyteCollin', rating: 5 },
  { key: 'nativid', rating: 5 },
];
